module.exports = __webpack_public_path__ + "img/brooke-cagle-g1Kr4Ozfoac-unsplash.8b03e1c6.png";